/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusGesetzeslisteStatusEnum } from '../../models/lexplus-gesetzesliste-status-enum';
import { LexplusKundendokumentListResponseDto } from '../../models/lexplus-kundendokument-list-response-dto';

export interface KundendokumentControllerFindAllPaginatedV1$Params {
  status?: Array<LexplusGesetzeslisteStatusEnum>;

/**
 * Page number to retrieve. If you provide invalid value the default page number will applied
 *
 * **Example:** 1
 *
 *
 * **Default Value:** 1
 */
  page?: number;

/**
 * Number of records per page.
 *
 *
 * **Example:** 20
 *
 *
 *
 * **Default Value:** 25
 *
 *
 *
 * **Max Value:** 100
 *
 *
 * If provided value is greater than max value, max value will be applied.
 */
  limit?: number;

/**
 * Filter by standortID query param.
 *
 * **Format:** filter.standortID={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.standortID=$eq:John Doe&filter.standortID=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $and
 *
 * - $or
 */
  'filter.standortID'?: Array<string>;

/**
 * Filter by publizierenAm query param.
 *
 * **Format:** filter.publizierenAm={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.publizierenAm=$btw:John Doe&filter.publizierenAm=$gte:John Doe
 *
 * **Available Operations**
 * - $gte
 *
 * - $lte
 *
 * - $btw
 *
 * - $and
 *
 * - $or
 */
  'filter.publizierenAm'?: Array<string>;

/**
 * Parameter to sort by.
 * To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting
 *
 * **Format:** {fieldName}:{DIRECTION}
 *
 *
 * **Example:** sortBy=publizierenAm:DESC&sortBy=kundendokumentID:DESC
 *
 *
 * **Default Value:** publizierenAm:DESC
 *
 * **Available Fields**
 * - publizierenAm
 *
 * - kundendokumentID
 *
 * - standortID
 */
  sortBy?: Array<'publizierenAm:ASC' | 'publizierenAm:DESC' | 'kundendokumentID:ASC' | 'kundendokumentID:DESC' | 'standortID:ASC' | 'standortID:DESC'>;

/**
 * Search term to filter result values
 *
 * **Example:** John
 *
 *
 * **Default Value:** No default value
 */
  search?: string;

/**
 * List of fields to search by term to filter result values
 *
 * **Example:** 
 *
 *
 * **Default Value:** By default all fields mentioned below will be used to search by term
 *
 * **Available Fields**
 */
  searchBy?: Array<string>;

/**
 * List of fields to select.
 *
 * **Example:** kundendokumentID,standortID,publizierenAm,standort.standortID,standort.name
 *
 *
 * **Default Value:** By default all fields returns. If you want to select only some fields, provide them in query param
 */
  select?: string;
}

export function kundendokumentControllerFindAllPaginatedV1(http: HttpClient, rootUrl: string, params?: KundendokumentControllerFindAllPaginatedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusKundendokumentListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, kundendokumentControllerFindAllPaginatedV1.PATH, 'get');
  if (params) {
    rb.query('status', params.status, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('filter.standortID', params['filter.standortID'], {});
    rb.query('filter.publizierenAm', params['filter.publizierenAm'], {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('search', params.search, {});
    rb.query('searchBy', params.searchBy, {});
    rb.query('select', params.select, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusKundendokumentListResponseDto>;
    })
  );
}

kundendokumentControllerFindAllPaginatedV1.PATH = '/v1/kundendokument/paginated';
